var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLubricant3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 48,
    viewBox: "0 0 134 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 134,
    height: 48,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.6672 35.6412H113.104V14.0488H91.6672V35.6412ZM104.911 33.7194H100.999V19.6851H98.3211V17.085C98.3211 17.085 100.774 17.5695 101.383 15.7446H104.911V33.7194Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.075 19.6523C40.5376 19.6523 36.866 23.3507 36.866 27.9211C36.866 32.4915 40.5376 36.1898 45.075 36.1898C49.5964 36.1898 53.2841 32.4915 53.2841 27.9211C53.2841 23.3507 49.5964 19.6523 45.075 19.6523ZM45.059 31.5548C43.0548 31.5548 41.4194 29.9237 41.4194 27.9049C41.4194 25.8862 43.0388 24.2389 45.059 24.2389C47.0632 24.2389 48.6986 25.87 48.6986 27.9049C48.6986 29.9075 47.0632 31.5548 45.059 31.5548Z",
    fill: "#D24023"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3225 17.0846V19.6847H101V33.7189H104.912V15.7441H101.385C100.776 17.5691 98.3225 17.0846 98.3225 17.0846Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8954 27.55L19.9833 14.0811H13.105V35.625H17.5943V20.5249L21.6989 35.5927H25.7072L30.1003 20.6218V35.5927H34.4935V14.0811H27.9038L23.8954 27.55Z",
    fill: "#293C90"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.643 19.7174C61.9434 19.7174 60.3882 20.3149 59.1055 21.3162V14.0811H54.7124V35.5765H59.1055V34.6237C60.3722 35.625 61.9434 36.2225 63.643 36.2225C67.8758 36.2225 71.3069 32.5242 71.3069 27.9538C71.323 23.4157 67.8758 19.7174 63.643 19.7174ZM63.1139 31.6683C61.1097 31.6683 59.4743 30.0371 59.4743 28.0022C59.4743 25.9835 61.0937 24.3524 63.1139 24.3524C65.118 24.3524 66.7534 25.9835 66.7534 28.0022C66.7534 30.0371 65.118 31.6683 63.1139 31.6683Z",
    fill: "#293C90"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1173 14.0967H79.7241V35.5922H84.1173V14.0967Z",
    fill: "#293C90"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3658 19.6689H72.9727V35.6412H77.3658V19.6689Z",
    fill: "#293C90"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3993 14H72.926V18.5058H77.3993V14Z",
    fill: "#293C90"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLubricant3);
export default __webpack_public_path__ + "static/media/lubricant3.63aed9489fc084bcb1d269a5578ba5a4.svg";
export { ForwardRef as ReactComponent };